var cov_1d10g0s2b3 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Cascader/List.tsx",
      hash = "90051b56ab0a54f80891cd5a3776b190e8c23690",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Cascader/List.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 21
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 16
        }
      },
      "2": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 19
        }
      },
      "3": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 42
        }
      },
      "4": {
        start: {
          line: 26,
          column: 33
        },
        end: {
          line: 26,
          column: 43
        }
      },
      "5": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 67
        }
      },
      "6": {
        start: {
          line: 27,
          column: 38
        },
        end: {
          line: 27,
          column: 67
        }
      },
      "7": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 34,
          column: 5
        }
      },
      "8": {
        start: {
          line: 29,
          column: 18
        },
        end: {
          line: 29,
          column: 30
        }
      },
      "9": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 32,
          column: 7
        }
      },
      "10": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 18
        }
      },
      "11": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 33,
          column: 64
        }
      },
      "12": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 51
        }
      },
      "13": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 57
        }
      },
      "14": {
        start: {
          line: 43,
          column: 31
        },
        end: {
          line: 43,
          column: 41
        }
      },
      "15": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 117
        }
      },
      "16": {
        start: {
          line: 44,
          column: 36
        },
        end: {
          line: 44,
          column: 117
        }
      },
      "17": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "18": {
        start: {
          line: 48,
          column: 21
        },
        end: {
          line: 48,
          column: 38
        }
      },
      "19": {
        start: {
          line: 49,
          column: 10
        },
        end: {
          line: 49,
          column: 87
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 46
          },
          end: {
            line: 23,
            column: 3
          }
        },
        line: 18
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        loc: {
          start: {
            line: 25,
            column: 47
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 25
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 23
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 38
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        loc: {
          start: {
            line: 42,
            column: 11
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 42
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 47,
            column: 18
          },
          end: {
            line: 47,
            column: 19
          }
        },
        loc: {
          start: {
            line: 47,
            column: 28
          },
          end: {
            line: 50,
            column: 9
          }
        },
        line: 47
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 67
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 67
          }
        }, {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 67
          }
        }],
        line: 27
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        }, {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 28,
            column: 8
          },
          end: {
            line: 28,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 8
          },
          end: {
            line: 28,
            column: 14
          }
        }, {
          start: {
            line: 28,
            column: 18
          },
          end: {
            line: 28,
            column: 44
          }
        }],
        line: 28
      },
      "3": {
        loc: {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 32,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 32,
            column: 7
          }
        }, {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 32,
            column: 7
          }
        }],
        line: 30
      },
      "4": {
        loc: {
          start: {
            line: 30,
            column: 10
          },
          end: {
            line: 30,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 10
          },
          end: {
            line: 30,
            column: 33
          }
        }, {
          start: {
            line: 30,
            column: 37
          },
          end: {
            line: 30,
            column: 60
          }
        }],
        line: 30
      },
      "5": {
        loc: {
          start: {
            line: 35,
            column: 23
          },
          end: {
            line: 35,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 35,
            column: 34
          },
          end: {
            line: 35,
            column: 37
          }
        }, {
          start: {
            line: 35,
            column: 40
          },
          end: {
            line: 35,
            column: 42
          }
        }],
        line: 35
      },
      "6": {
        loc: {
          start: {
            line: 39,
            column: 11
          },
          end: {
            line: 39,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 11
          },
          end: {
            line: 39,
            column: 39
          }
        }, {
          start: {
            line: 39,
            column: 43
          },
          end: {
            line: 39,
            column: 57
          }
        }],
        line: 39
      },
      "7": {
        loc: {
          start: {
            line: 39,
            column: 12
          },
          end: {
            line: 39,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 12
          },
          end: {
            line: 39,
            column: 27
          }
        }, {
          start: {
            line: 39,
            column: 31
          },
          end: {
            line: 39,
            column: 33
          }
        }],
        line: 39
      },
      "8": {
        loc: {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 117
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 117
          }
        }, {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 117
          }
        }],
        line: 44
      },
      "9": {
        loc: {
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 44,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 44,
            column: 13
          }
        }, {
          start: {
            line: 44,
            column: 17
          },
          end: {
            line: 44,
            column: 34
          }
        }],
        line: 44
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Cascader/List.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import { cascaderClass } from './styles';
import Node from './Node';
import { getLocale } from '../locale';
import { getDirectionClass } from '../utils/classname';
var DefaultProps = (cov_1d10g0s2b3.s[0]++, {
  id: '',
  parentId: '',
  text: {}
});

var List =
/*#__PURE__*/
function (_Component) {
  _inherits(List, _Component);

  var _super = _createSuper2(List);

  function List(props) {
    var _this;

    _classCallCheck(this, List);

    cov_1d10g0s2b3.f[0]++;
    cov_1d10g0s2b3.s[1]++;
    _this = _super.call(this, props);
    cov_1d10g0s2b3.s[2]++;
    _this.state = {};
    cov_1d10g0s2b3.s[3]++;
    _this.getText = _this.getText.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(List, [{
    key: "getKey",
    value: function getKey(data, index) {
      cov_1d10g0s2b3.f[1]++;

      var _ref = (cov_1d10g0s2b3.s[4]++, this.props),
          keygen = _ref.keygen,
          parentId = _ref.parentId;

      cov_1d10g0s2b3.s[5]++;

      if (typeof keygen === 'function') {
        cov_1d10g0s2b3.b[0][0]++;
        cov_1d10g0s2b3.s[6]++;
        return keygen(data, parentId);
      } else {
        cov_1d10g0s2b3.b[0][1]++;
      }

      cov_1d10g0s2b3.s[7]++;

      if ((cov_1d10g0s2b3.b[2][0]++, keygen) && (cov_1d10g0s2b3.b[2][1]++, typeof keygen === 'string')) {
        cov_1d10g0s2b3.b[1][0]++;
        var key = (cov_1d10g0s2b3.s[8]++, data[keygen]);
        cov_1d10g0s2b3.s[9]++;

        if ((cov_1d10g0s2b3.b[4][0]++, typeof key === 'string') || (cov_1d10g0s2b3.b[4][1]++, typeof key === 'number')) {
          cov_1d10g0s2b3.b[3][0]++;
          cov_1d10g0s2b3.s[10]++;
          return key;
        } else {
          cov_1d10g0s2b3.b[3][1]++;
        }

        cov_1d10g0s2b3.s[11]++;
        console.error('key must be number or string but get', key);
      } else {
        cov_1d10g0s2b3.b[1][1]++;
      }

      cov_1d10g0s2b3.s[12]++;
      return parentId + (parentId ? (cov_1d10g0s2b3.b[5][0]++, ',') : (cov_1d10g0s2b3.b[5][1]++, '')) + index;
    }
  }, {
    key: "getText",
    value: function getText(key) {
      cov_1d10g0s2b3.f[2]++;
      cov_1d10g0s2b3.s[13]++;
      return (cov_1d10g0s2b3.b[6][0]++, ((cov_1d10g0s2b3.b[7][0]++, this.props.text) || (cov_1d10g0s2b3.b[7][1]++, {}))[key]) || (cov_1d10g0s2b3.b[6][1]++, getLocale(key));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      cov_1d10g0s2b3.f[3]++;

      var _ref2 = (cov_1d10g0s2b3.s[14]++, this.props),
          data = _ref2.data,
          other = _objectWithoutProperties(_ref2, ["data"]);

      cov_1d10g0s2b3.s[15]++;

      if ((cov_1d10g0s2b3.b[9][0]++, !data) || (cov_1d10g0s2b3.b[9][1]++, data.length === 0)) {
        cov_1d10g0s2b3.b[8][0]++;
        cov_1d10g0s2b3.s[16]++;
        return (
          /*#__PURE__*/
          React.createElement("span", {
            className: cascaderClass('no-data'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 44,
              columnNumber: 44
            }
          }, this.getText('noData'))
        );
      } else {
        cov_1d10g0s2b3.b[8][1]++;
      }

      cov_1d10g0s2b3.s[17]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: cascaderClass(getDirectionClass('list')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 46,
            columnNumber: 7
          }
        }, data.map(function (d, i) {
          cov_1d10g0s2b3.f[4]++;
          var id = (cov_1d10g0s2b3.s[18]++, _this2.getKey(d, i));
          cov_1d10g0s2b3.s[19]++;
          return (
            /*#__PURE__*/
            React.createElement(Node, Object.assign({}, other, {
              key: id,
              active: other.id === id,
              id: id,
              data: d,
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 49,
                columnNumber: 18
              }
            }))
          );
        }))
      );
    }
  }]);

  return List;
}(Component);

List.defaultProps = DefaultProps;
export default List;